import GATSBY_COMPILED_MDX from "/opt/build/repo/e-learning/content/learning-units/lu-20/1_beginning-of-arms-control.mdx";
import React from 'react';
import {graphql, Link} from 'gatsby';
import {getSrc} from 'gatsby-plugin-image';
import App from './App';
import Meta from './Meta';
import PostBody from './PostBody';
import StickyHeader from './StickyHeader';
import TableOfContents from './TableOfContents';
import * as styles from './Chapter.module.scss';
export const query = graphql`
  query ($id: String, $lu_id: String) {
    site: site {
      siteMetadata {
        title
      }
    }
    post: file(id: { eq: $id }) {
      id
      childMdx {
        tableOfContents
        fields {
          slug
        }
        frontmatter {
          title
          intro
          order
          reading_time
        }
      }
    }
    chapters: allFile(
      filter: { relativeDirectory: { eq: $lu_id }, name: { nin: ["index", "__print"] }, ext: { eq: ".mdx" } }
      sort: { childMdx: { frontmatter: { order: ASC } } }
    ) {
      nodes {
        name
        id
        childMdx {
          fields {
            slug
          }
          frontmatter {
            title
            intro
            order
          }
        }
      }
    }
    unit: file(name: { eq: "index" }, relativeDirectory: { eq: $lu_id }) {
      name
      childMdx {
        fields {
          slug
        }
        frontmatter {
          title
          short_title
          order
          hero_background
        }
      }
    }
  }
`;
const Chapter = ({data, children}) => {
  const frontmatter = data.post.childMdx.frontmatter;
  const currentIndex = data.chapters.nodes.findIndex(el => {
    return el.childMdx.frontmatter.order === frontmatter.order;
  });
  const next = data.chapters.nodes[currentIndex + 1];
  const prev = data.chapters.nodes[currentIndex - 1];
  return React.createElement(App, null, React.createElement(StickyHeader, {
    unit: data.unit,
    post: data.post,
    next: next,
    prev: prev,
    chapters: data.chapters.nodes
  }), React.createElement("article", {
    id: "content"
  }, React.createElement("header", {
    className: styles.header
  }, React.createElement("div", {
    className: styles.headerCopy
  }, React.createElement("span", {
    className: styles.eyebrow
  }, "Chapter ", frontmatter.order), React.createElement("h1", {
    className: styles.title
  }, frontmatter.title), frontmatter.intro && React.createElement("p", {
    className: styles.intro
  }, frontmatter.intro))), React.createElement("div", {
    className: styles.body
  }, data.post.childMdx.tableOfContents.items?.length > 1 && React.createElement("aside", {
    className: styles.tocContainer
  }, React.createElement("div", {
    className: styles.tocInner
  }, React.createElement("h4", null, "On this page"), React.createElement(TableOfContents, {
    items: data.post.childMdx.tableOfContents.items
  }))), React.createElement("div", {
    className: styles.bodyText
  }, React.createElement(PostBody, {
    content: children
  })), React.createElement("nav", {
    className: styles.pagination
  }, next && next.childMdx.frontmatter.title && React.createElement(Link, {
    className: styles.next,
    to: `../${next.childMdx.fields.slug}`
  }, React.createElement("span", {
    className: styles.paginationLabel
  }, "Next Chapter"), React.createElement("span", {
    className: styles.paginationTitle
  }, next.childMdx.frontmatter.order, ". ", next.childMdx.frontmatter.title), next.childMdx.frontmatter.intro && React.createElement("p", {
    className: styles.paginationIntro
  }, next.childMdx.frontmatter.intro)), prev && React.createElement("p", {
    className: styles.previous
  }, React.createElement("span", null, "Previous Chapter:"), " ", React.createElement(Link, {
    to: `../${prev.childMdx.fields.slug}`
  }, prev.childMdx.frontmatter.title))))));
};
export function Head({data}) {
  const chapter = data.post.childMdx.frontmatter;
  const unit = data.unit.childMdx.frontmatter;
  const intro = '';
  return React.createElement(Meta, {
    socialTitle: `${chapter.title} – ${unit.title}`,
    title: `${chapter.title} – ${unit.title} / ${data.site.siteMetadata.title}`,
    description: intro,
    image: {
      src: getSrc(unit.hero_image),
      alt: unit.hero_alt
    }
  });
}
Chapter
export default function GatsbyMDXWrapper(props) {
  return React.createElement(Chapter, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
